import * as React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { CustomSnackbarContentWrapper } from "./CustomSnackbar";


const SuccessSnackbar: React.SFC<{successMessage?: string, onClose: () => void}> = props => (
    <Snackbar
        open={props.successMessage != null}
        onClose={props.onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
        <CustomSnackbarContentWrapper
            onClose={props.onClose}
            variant="success"
            message={props.successMessage}
        />
    </Snackbar>
);

export default SuccessSnackbar;